import React from "react";
import {
  Heading,
  TextWrapper,
  ImageWrapper,
  MoneyBackGuaranteeContainer,
  Wrapper,
  ExploreTeachersContainer,
  ExploreCTA,
  ImageContainer
} from "./explore-teachers.styles";
import Exploreteacher from "public/assets/champion/exploreteacher.jpg";

export const ExploreTeachers: React.FC = () => {
  return (
    <Wrapper>
      <ExploreTeachersContainer>
        <MoneyBackGuaranteeContainer>
          <TextWrapper>
            <Heading>Guru yang memotivasi, penjelasan mudah dipahami</Heading>
            <ExploreCTA rel="nofollow" href="/akademi">
              Siapa Guru Juara CoLearn? Klik!
            </ExploreCTA>
          </TextWrapper>

          <ImageWrapper>
            <ImageContainer
              src={Exploreteacher}
              alt="CoLearn aplikasi belajar Matematika Fisika Kimia"
              layout="responsive"
            />
          </ImageWrapper>
        </MoneyBackGuaranteeContainer>
      </ExploreTeachersContainer>
    </Wrapper>
  );
};
